export enum OrderStatusEnum {
  Assigned = 1,
  Transit = 2,
  Delivered = 3,
  Invoiced = 4,
  Paid = 5,
  Received = 10,
  CancelProcess = 12,
  ReturnProcess = 13,
  Returned = 14,
  ReturnApprovalProcess = 16,
  WaitingRelease = 17
}

